import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { lastUnansweredMedicalSlot } from "./store";
import moment from "moment";
import { isEmpty } from "lodash";
import { languageBarriersDisposition, NULL_VALUES } from "config";
import { useDeleteTag, useSetTag } from "modules/nextcall/store";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { TAG_ID } from "config";
import { Radio, Select, Typography } from 'antd';
import { Space } from 'antd/lib';

function CallResponse({ formData, buttonStyle, selected, setFormData, formRow, isValid = true, bookingId = null}) {
  const [responseFlag, setResponseFlag] = useState(false);
  const { setTagToCase } = useSetTag();
  const { deleteTagFromCase } = useDeleteTag();
  const { id } = useParams();
  useEffect(() => {
    if (isEmpty(formData.callResponse)) {
      return;
    }
    if (!id) {
      toast.success("Mark DND Flag on lead details page");
      return;
    }
    if (formData.callResponse == "dndMode") {
      setTagToCase(id, TAG_ID);
      toast.success("Added DND Mode");
      setFormData((prevFormData) => ({
        ...prevFormData,
        dnd: true,
      }));
      setResponseFlag(true);
    } else if(responseFlag) {
      deleteTagFromCase(id, TAG_ID);
      toast.warning("Removed DND Mode");
      setFormData((prevFormData) => ({
        ...prevFormData,
        dnd: false,
      }));
      setResponseFlag(false);
    }
  }, [formData.callResponse]);

  const handleCallResponse = (response) => {
    setFormData((prevFormData) => {
      const { languageBarrier, comments, ...rest} = prevFormData;
      return {...rest, callResponse: response }
    })
  };

  const handleLanguageBarrierChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      languageBarrier: value,
    }));
  };

  const { lastUnansweredMedicalSlotData, calllastUnansweredMedicalSlot } = lastUnansweredMedicalSlot();

  useEffect(() => {
    if (NULL_VALUES.includes(bookingId) && !isEmpty(bookingId)) {
      calllastUnansweredMedicalSlot(bookingId);
    }
  }, [bookingId]);

  const callResponseOptions = [
    { value: "answered", label: "Answered" },
    { value: "unanswered", label: "Not Answered", disabled: isWithinLast45Minutes(lastUnansweredMedicalSlotData.last_unanswered) },
    { value: "languageIssue", label: "Language Issue" },
    { value: "dndMode", label: "DND Mode" },
  ];

  function isWithinLast45Minutes(timestamp) {
    if (!timestamp) {
      return false;
    }
    const lastUnansweredTime = moment(timestamp);
    const currentTime = moment();

    return currentTime.diff(lastUnansweredTime, "minutes") <= 45;
  }

  const handleDndComment = (event) => {
    const { value } = event.target;
    setFormData((prevFormData) => ({...prevFormData,comments: value}));
  };
  return (
    <div>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="mr-auto p-2"><h4>Call Response</h4></div>
        <div class="p-2">
          <Radio.Group
          options={callResponseOptions}
          onChange={(event)=>{handleCallResponse(event.target.value)}}
          value={formData.callResponse}
          optionType="button"
          buttonStyle="solid"
          />
        </div>
      </div>         

      {formData.callResponse === "languageIssue" && (
        <Space.Compact block className='my-4'>
        <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }} className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
            <Typography.Text>Language barrier</Typography.Text>
        </span>
        <Select
            showSearch
            placeholder='Choose one'
            style={{ width: '70%' }}
            optionFilterProp="label"
            onChange={(value) => handleLanguageBarrierChange(value)}
            allowClear
            options={languageBarriersDisposition}
        />
      </Space.Compact>
      )}
      {formData.callResponse === "dndMode" && (
        <div className="mt-3">
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Please Add Comment</Form.Label>
            <Form.Control as="textarea" rows={3} onChange={handleDndComment} />
          </Form.Group>
        </div>
      )}
    </div>
  );
}

export default CallResponse;